import React, { useEffect, useState, memo } from "react";
import { Col, Button, Form, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { callApi, validateToken } from "../../../../lib/utils";
import SelectField from "../../SelectField";
import TaskNotesList from "../TaskNotesList";
import moment from "moment-timezone";

import "./index.css";

const TaskNoteForm = ({ data, noteTypes, heading, noteModuleId, patientTaskId, eventTypeId }) => {

  const [loading, setLoading] = useState(false);
  //const [noteTypes, setNoteTypes] = useState([]);
  const [note, setNote] = useState('');
  const [saveNote, setSaveNote] = useState([]);
  const [selectedNoteType, setSelectedNoteType] = useState();
  const handleNotesType = (e) => {
    setSelectedNoteType(e.target.value);
  };
  const handleInputChange = (e) => {
    setNote(e.target.value);
  };

  useEffect(() => {
    if (eventTypeId) {
      setSelectedNoteType(9);
    }
  }, [eventTypeId]);

  // useEffect(() => {
  //   validateToken((err) => {
  //     if (err) {
  //       // console.log(err);
  //       window.location = "/logout";
  //     }
  //     setLoading(true);
  //     callApi(`/api/patient/note/types`, {}, "GET")
  //       .then((response) => {
  //         const temp = response?.data.data?.noteTypes
  //           ? response?.data.data?.noteTypes.map((item) => {
  //               return { id: item.id, name: item.noteType };
  //             })
  //           : [];
  //         setNoteTypes(temp);
  //       })
  //       .catch((err) => {
  //         console.log("err: ", err);
  //         setLoading(false);
  //       });
  //   });
  // }, []);

  const handleSaveNote = () => {
    validateToken((err) => {
      if (err) {
        // console.log(err);
        window.location = "/logout";
      }
      setLoading(true);
      callApi(
        `/api/patient/note/`,
        {
          patientId: data.patientId,
          noteTypeId: parseInt(selectedNoteType),
          noteModuleId: noteModuleId,
          referenceId: data?.referenceId ? data?.referenceId : data?.id,
          notes: note,
          timezone: moment.tz.guess(),
          eventTypeId: data?.eventType,
          patientTaskId: patientTaskId

        },
        "POST"
      ).then((response) => {
        setSaveNote([...saveNote, response?.data?.data?.note]);
        setLoading(false);
        setNote('');
      })
    }).catch((err) => {
      console.log("err: ", err);
      setLoading(false);
    });
  };
  return (

    <>
      <Col
        className="task-notes-container"
        style={{
          background: "rgb(233, 235, 236)",
          minHeight: "calc(90vh - 120px)",
        }}
      >
        <Row className="notes-heading">
          <Col md="4">
            <h5>{heading ? heading : "NEW NOTES"}</h5>
          </Col>
          {!heading && (
            <Col md="8">
              <p className="text-align-right">{data?.taskMetadata?.email}</p>
              <p className="text-align-right">
                {data?.taskMetadata?.eventDateTime}
              </p>
            </Col>
          )}
        </Row>
        <Row className="justify-content-md-end">
          <Col md="6">
            {/* <SelectField
              name="Notes Type"
              action={handleNotesType}
              //options={noteTypes}
              options="General Note"
              required={true}
              disabled={false}
              id="Note"
              placeholder="Notes Type"

            /> */}
          </Col>
        </Row>
        <Row className="justify-content-md-start">
          <Col md="6">
            <Form.Group controlId="Note" className="mb-2">
              <Form.Label><b>Note Type</b></Form.Label>
              <SelectField
                value={selectedNoteType}
                name="Note Type"
                action={handleNotesType}
                options={noteTypes}
                //options="General Note"
                required={true}
                id="Note"
                //placeholder="Notes Type"
                disabled={!!eventTypeId}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col>
            <Form.Control
              as="textarea"
              placeholder="Enter notes ..."
              style={{ width: "100%" }}
              rows={7}
              id="noteText"
              onChange={handleInputChange}
              name="noteText"
              value={note}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <Button
              className="btn btn-success pull-right"
              disabled={!note?.length || !selectedNoteType}
              id="saveNote"
              onClick={handleSaveNote}
            >
              Save Note
            </Button>
          </Col>
        </Row>
        {(!!Object.keys(saveNote)?.length || loading) && (
          <Row>
            <Col>
              <TaskNotesList
                noteTypes={noteTypes}
                notesList={saveNote}
                col={12}
                data={data}
                loading={loading}
              />
            </Col>
          </Row>
        )}
      </Col>
    </>
  );
};

export default memo(TaskNoteForm);
